import './JSONAnnotationTask.module.less'
import { UpdatableReactElement } from 'shared/utils/react.utils'

export type JSONAnnotationTaskUiProps = {
    jsonAnnotationUI: UpdatableReactElement
}

export const JSONAnnotationTaskUi = (props: JSONAnnotationTaskUiProps) => {
    return <div data-testid="JSONAnnotation-task-ui-wrapper">{props.jsonAnnotationUI.element}</div>
}
